import React from "react";

export function usePreventBrowserBack() {
  React.useEffect(() => {
    // update history first the first time when component is mounted
    window.history.pushState(null, "", window.location.href);

    function preventBack() {
      // add the same state when user press browser's back button
      window.history.pushState(null, "", window.location.href);
    }

    // listener on back press action
    window.addEventListener("popstate", preventBack);

    // remove handler on component unmount
    return () => window.removeEventListener("popstate", preventBack);
  }, []);
}
